import BaseApi from 'api/BaseApi';

export interface IAutomationWorkflow {
  id: string;
}

export interface IFindAutomationWorkflowsParams {
  productId: string;
  ids: string[];
}

export interface IAutomationWorkflowsApi {
  find(params: IFindAutomationWorkflowsParams): Promise<IAutomationWorkflow[]>;
}

export default class AutomationWorkflowsApi extends BaseApi implements IAutomationWorkflowsApi {
  public async find(params: IFindAutomationWorkflowsParams): Promise<IAutomationWorkflow[]> {
    const urlSearchParams = new URLSearchParams();

    urlSearchParams.append('productId', params.productId);
    urlSearchParams.append('ids', params.ids.join(','));


    return this.fetch(`/automation-workflows?${urlSearchParams}`);
  }
}
